import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '../../shared/TextField';
import { color } from '../../../app/theme';
import IconDelete from '../../../assets/images/Icons/IconDelete';
import { setData, disconnect } from '../../../features/ecBindingSlice';
import { openModal, closeModal } from '../../../features/modalSlice';
import { ModalType } from '../../../app/types';
import Button from '../../shared/Button';

const useStyles = makeStyles(
  {
    root: {},
    header: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$13,
      margin: '0 0 40px 0',
    },
    text: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$11,
      marginBottom: 12,
      maxWidth: 676,
      '& > a': {
        color: color.$2,
      },
    },
    title: {
      fontSize: '20px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 12,
    },
    inputBlock: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 12,
    },
    stop: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '15px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$10,
      cursor: 'pointer',
      '& > svg': {
        marginRight: 4,
      },
    },
    hr: {
      backgroundColor: color.$9,
      height: 1,
      width: '100%',
      margin: '24px 0',
    },
    subtitle: {
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: color.$11,
      marginTop: 6,
      '& > a': {
        color: color.$2,
        textDecoration: 'underline',
      },
    },
    button: {
      marginLeft: 12,
      width: 150,
      cursor: 'default !important',
    },
  },
  {
    name: 'CyberbizTokenContainer',
  },
);

const CyberbizTokenContainer = ({ provider }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { orgId } = useParams();
  const { data } = useSelector(store => store.ecBinding);
  const { shopUrl } = data || {};

  const handleStop = () => {
    dispatch(
      openModal({
        modalType: ModalType.ALERT_MODAL,
        modalProps: {
          title: t(`ecBinding:cyberbiz-disconnectTitle`),
          content: t(`ecBinding:cyberbiz-disconnectSubtitle`),
          onCancel: () => {
            dispatch(closeModal());
          },
          onClick: async () => {
            await dispatch(disconnect(orgId, provider));
            dispatch(
              setData({
                shopUrl: '',
              }),
            );
            dispatch(closeModal());
          },
          cancelText: t('modal.cancel'),
          submitText: t('modal.sure'),
        },
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {t(`ecBinding:cyberbiz-token`)}
        <div className={classes.subtitle}>
          {t(`ecBinding:cyberbiz-subtitle`)}
          <a
            href={t(`ecBinding:cyberbiz-token-helpUrl`)}
            rel="noopener noreferrer"
            target="_blank"
            className="link"
          >
            {t('mitake:help')}
          </a>
        </div>
      </div>
      <div className={classes.title}>
        {t('ecBinding:cyberbiz-token-step1-title')}
      </div>
      <div className={classes.text}>
        {t('ecBinding:cyberbiz-token-step1-subtitle-1')}
        <a
          href={t(`ecBinding:cyberbizUrl`)}
          rel="noopener noreferrer"
          target="_blank"
          className="link"
        >
          {t(`ecBinding:cyberbizUrl-text`)}
        </a>
        <span
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: t(`ecBinding:cyberbiz-token-step1-subtitle-2`),
          }}
        />
        {shopUrl && (
          <div className={classes.inputBlock}>
            <TextField
              className={classes.input}
              type="text"
              isValid
              value={shopUrl || ''}
              onChange={() => {}}
              disabled
            />
            <Button className={classes.button} topic="primaryGreen">
              {t('ecBinding:cyberbiz-connect')}
            </Button>
          </div>
        )}
      </div>
      {shopUrl && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 12,
            marginBottom: 44,
          }}
        >
          <div className={classes.text} style={{ margin: 0 }} />
          <div className={classes.stop} onClick={handleStop}>
            <IconDelete
              id="stop-connect"
              width={20}
              height={20}
              color={color.$10}
              hoverColor={color.$10}
            />
            {t(`ecBinding:cyberbiz-stop-connect`)}
          </div>
        </div>
      )}
    </div>
  );
};

export default CyberbizTokenContainer;
